import '@/installFineMq'

import hateoasIndex from '@/hateoas-index.js'
import http from '@/helpers/http'
import { mount } from '@/mounter'

import router from './router'
import SanitasContactWizard from './SanitasContactWizard'

http.create({
  axiosConfig: {
    baseURL: '/',
  },
})

// For dynamically loaded forms using the api
const config = window.Sanitas?.SanitasFormsConfig || {}

http.createHateoas({
  name: 'api',
  rootEndpoint: hateoasIndex,
  axiosConfig: {
    baseURL: config.apiUrl || '/public',
  },
})

mount('contact-wizard', SanitasContactWizard, {}, { router })
